import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ERACustomizerProvider } from "src/contexts/era-package/EraCustomizerContext";
import { ThemeSettings } from "src/theme/era-package/Theme";


// splitting as inner component uses context
const Mui5Inner = ({ children }) => {
  const theme = ThemeSettings()

  // console.log('theme', theme)

  return <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
}

const Mui5AppHolder = ({ children }) => <>
  <ERACustomizerProvider>
    <Mui5Inner>{children}</Mui5Inner>
  </ERACustomizerProvider>
</>

export default Mui5AppHolder;